const article = {
  slug: 'collections',
  title: 'Late fees, liens, auctions',
  section: 'Collections',
  body: `
# Collections timeline

## Automated (configured in Settings -> Fees / Late & Lien)

- Invoice unpaid past due -> late-fee tiers fire on your configured days
  and the tenant is notified each step.
- The rental flips **Delinquent**; automated notices stop at the end of
  the chain - the lien process is deliberately manual from there.

## Lien workflow (manual, operator-driven)

The **workflow engine** walks the statutory lien steps one at a time -
notice letters (generated from your templates), certified-mail windows,
waiting periods, auction scheduling. One step is active at a time; each
is marked done by you or auto-completes on its timer. Documents merge
tenant/unit data and send with the facility CC'd.

## Auctions

Auction outcomes (sale proceeds, cleanout) settle against the balance;
force move-out closes the file - any remaining balance is written off
as part of the move-out itself, per invoice, so it stays reportable.

> Statutory timelines vary by state - the workflow templates encode the
> process you configure; confirm dates against your state statute.
`,
};

export default article;
